/**
 * Normalize an unknown caught value to an `Error` instance. Useful when
 * passing to loggers or error handlers that require a proper Error.
 */
export const toError = (e: unknown): Error => (e instanceof Error ? e : new Error(String(e)));
